import { Checklist } from "@/bryntum-lib/models/Checklist";
import { ChecklistItems } from "@/bryntum-lib/models/ChecklistItems";
import { cn } from "@/modern/utils";

interface ChecklistProgressProps {
  checklist: Checklist;
  checklistItems?: ChecklistItems[];
  barContainerClassName?: string;
  textClassName?: string;
}

export const ChecklistProgress = ({ checklist, checklistItems, barContainerClassName, textClassName }: ChecklistProgressProps) => {
  // If checklistItems is not provided, calculate from the checklist model
  const items = checklistItems || checklist.checklistItems || [];

  const completedItems = items.filter((item: ChecklistItems) => item.isItemCheck).length;
  const totalItems = items.length;
  const progress = totalItems > 0 ? (completedItems / totalItems) * 100 : 0;

  return (
    <div className="flex items-center gap-3">
      <div className={cn("flex-1 h-2 bg-secondary rounded-full overflow-hidden", barContainerClassName)}>
        <div className="h-full bg-primary rounded-full transition-all duration-300" style={{ width: `${progress}%` }} />
      </div>
      <span className={cn("text-sm text-muted-foreground whitespace-nowrap", textClassName)}>
        {completedItems} of {totalItems}
      </span>
    </div>
  );
};
